module.exports = __webpack_public_path__ + "img/nepaLogo.1b812806.svg";